<div class="row justify-content-between">
    <div class="col-auto">
        <h5>{{ "GENERAL.RANKINGS" | translate }}</h5>
    </div>
    <div class="col-auto">
        <app-shared-filter [filter]="filters" (onChange)="onFilterChange($event)"></app-shared-filter>
    </div>
</div>
<div [nbSpinner]="loading" style="min-height: 200px">
    <div *ngIf="statusCode == 0" class="ranking">
        <app-card-ranking *ngFor="let ranking of list" [ranking]="ranking" [linkRoute]="linkRoute"></app-card-ranking>
    </div>

    <h2 class="not-found" *ngIf="statusCode > 0">
        Ops!
        <br />
        <span>{{ message }}</span>
    </h2>
    
    <h2 class="not-found" *ngIf="statusCode === 0 && !list">
        Ops!
        <br />
        <span>{{ "MESSAGE.RESULT.TRANSACTION-WITHOUT-RETURN" | translate }}</span>
    </h2>
    
</div>

